import { CalendarDays, ExternalLink, Flag, Mountain, Route, Sparkles, X } from 'lucide-react'
import PhotoGallery from './PhotoGallery'

function formatDate(value) {
  if (!value) return 'Date not set'
  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(new Date(`${value}T12:00:00`))
}

export default function CountryDrawer({ summit, trip, photos = [], onClose }) {
  if (!summit) return null

  return (
    <aside className="country-drawer" aria-live="polite">
      <button className="icon-button country-drawer__close" onClick={onClose} aria-label="Close summit details">
        <X size={18} />
      </button>

      {photos.length > 0 ? (
        <div className="country-drawer__photo-gallery">
          <PhotoGallery photos={photos} compact />
          <div className={`status-chip status-chip--${summit.status}`}>{summit.status}</div>
        </div>
      ) : (
        <div className="country-drawer__hero">
          {summit.hero_image_url ? (
            <img src={summit.hero_image_url} alt={`${summit.peak_name}, ${summit.country_name}`} />
          ) : (
            <div className="country-drawer__mountain-art" aria-hidden="true">
              <span>{summit.flag || '🏔️'}</span>
            </div>
          )}
          <div className={`status-chip status-chip--${summit.status}`}>{summit.status}</div>
        </div>
      )}

      <div className="country-drawer__body">
        <div className="eyebrow">{summit.country_name}</div>
        <h2>{summit.peak_name}</h2>
        <p className="country-drawer__elevation">{Number(summit.elevation_m || 0).toLocaleString()} m</p>

        <div className="detail-grid">
          <div>
            <Mountain size={16} />
            <span>{summit.difficulty || 'Difficulty not set'}</span>
          </div>
          <div>
            <CalendarDays size={16} />
            <span>{formatDate(summit.summit_date)}</span>
          </div>
          <div>
            <Route size={16} />
            <span>{trip?.name || 'Independent summit'}</span>
          </div>
          <div>
            {summit.scenic_choice ? <Sparkles size={16} /> : <Flag size={16} />}
            <span>{summit.scenic_choice ? 'Iconic / scenic choice' : 'Country summit target'}</span>
          </div>
        </div>

        {summit.route_notes && (
          <div className="drawer-section">
            <div className="section-label">Route notes</div>
            <p>{summit.route_notes}</p>
          </div>
        )}

        {(summit.reel_url || summit.hero_image_url) && (
          <div className="drawer-actions">
            {summit.reel_url && (
              <a className="primary-button" href={summit.reel_url} target="_blank" rel="noreferrer">
                Watch reel <ExternalLink size={15} />
              </a>
            )}
          </div>
        )}
      </div>
    </aside>
  )
}
